import { usePaymentMethodsWithIssues } from '@sola/supporter-sdk/hooks/payment-methods.ts';

import {
  PaymentMethodAlert,
  PaymentMethodAlertProps,
  shouldRenderPaymentMethodAlert,
} from '../../molecules/payment-method-alert/payment-method-alert.tsx';
import {
  MakeAPaymentNotice,
  MakeAPaymentNoticeProps,
} from '../make-a-payment/make-a-payment-notice.tsx';

export const PaymentIssueAlert: React.FC<
  PaymentMethodAlertProps & MakeAPaymentNoticeProps
> = (alertProps) => {
  const {
    paymentMethodsWithIssues,
    // TODO: Open question to UX as to whether we should care if the payment method with issues has commitments
    associatedCommitments,
  } = usePaymentMethodsWithIssues();

  const { isSimple, onlyShowMissingPayment } = alertProps;

  if (
    shouldRenderPaymentMethodAlert({
      paymentMethodsWithIssues,
      associatedCommitments,
      isSimple,
    })
  ) {
    return <PaymentMethodAlert isSimple={isSimple} />;
  }

  return <MakeAPaymentNotice onlyShowMissingPayment={onlyShowMissingPayment} />;
};
